<div class="ui segment" [class.loading]="(isLoading$ | async) || isSubmittingForm">
  <h1 data-lokalise data-key="txt_billing_address_page_title"></h1>

  <gd-form-error-message [error]="error" [isVisible]="!!error" (dismiss)="error = null"> </gd-form-error-message>

  <div class="ui form">
    <div
      *ngIf="(originalCompanyDetails$ | async) && !(originalCompanyDetails$ | async).companyName"
      class="field"
      [class.error]="hasError('companyName')"
    >
      <label data-lokalise data-key="txt_company_name_field_label"></label>
      <div class="ui input fluid">
        <input placeholder="" [(ngModel)]="companyDetails.companyName" name="companyName" />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'companyName'"> </gd-form-field-error-message>
    </div>
    <div class="field" [class.error]="hasError('recipientName')">
      <label data-lokalise data-key="txt_recipient_name_field_label"></label>
      <div class="ui input fluid">
        <input placeholder="" [(ngModel)]="companyDetails.recipientName" name="recipientName" />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'recipientName'"> </gd-form-field-error-message>
    </div>
    <div class="field" [class.error]="hasError('address')">
      <label data-lokalise data-key="txt_address_field_label"></label>
      <div class="ui input fluid">
        <input placeholder="" [(ngModel)]="companyDetails.address" name="address" />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'address'"> </gd-form-field-error-message>
    </div>

    <div class="fields">
      <div class="eight wide field" [class.error]="hasError('postCode')">
        <label data-lokalise data-key="txt_address_postcode_field_label"></label>
        <div class="ui input fluid">
          <input placeholder="" [(ngModel)]="companyDetails.postCode" name="postCode" />
        </div>
        <gd-form-field-error-message [error]="error" [fieldName]="'postCode'"> </gd-form-field-error-message>
      </div>

      <div class="eight wide field" [class.error]="hasError('city')">
        <label data-lokalise data-key="txt_address_city_field_label"></label>
        <div class="ui input fluid">
          <input placeholder="" [(ngModel)]="companyDetails.city" name="city" />
        </div>
        <gd-form-field-error-message [error]="error" [fieldName]="'city'"> </gd-form-field-error-message>
      </div>
    </div>

    <div class="fields">
      <div class="eight wide field" [class.error]="hasError('stateCode')">
        <label>
          {{ 'txt_address_state_field_label' | translate }}
          <ng-container *ngIf="companyDetails.countryIsoCode | isStateFieldOptional">
            ({{ 'txt_optional_field_label' | translate }})
          </ng-container>
        </label>

        <gd-country-state-selector
          [countryIsoCode]="companyDetails.countryIsoCode"
          [value]="companyDetails.stateCode"
          (valueChange)="companyDetails.stateCode = $event"
        >
        </gd-country-state-selector>

        <gd-form-field-error-message [error]="error" [fieldName]="'stateCode'"> </gd-form-field-error-message>
      </div>

      <div class="eight wide field" [class.error]="hasError('countryIsoCode')">
        <label data-lokalise data-key="txt_address_country_field_label"></label>
        <gd-country-selector
          [value]="companyDetails.countryIsoCode"
          (valueChange)="onCountryIsoCodeChange($event)"
        ></gd-country-selector>
        <gd-form-field-error-message [error]="error" [fieldName]="'countryIsoCode'"> </gd-form-field-error-message>
      </div>
    </div>

    <div class="fields">
      <div class="eight wide field" [class.error]="hasError('phone')">
        <label data-lokalise data-key="txt_address_phone_field_label"></label>
        <div class="ui input fluid">
          <ui-phone-field
            [phoneNumber]="companyDetails.phone"
            [countryCode]="companyDetails.countryIsoCode"
            (phoneChange)="onPhoneChange($event)"
          ></ui-phone-field>
        </div>
        <gd-form-field-error-message [error]="error" [fieldName]="'phone'"> </gd-form-field-error-message>
      </div>
    </div>
  </div>
</div>
<div class="buttons">
  <button
    type="button"
    class="ui primary button"
    [class.disabled]="(isLoading$ | async) || isSubmittingForm"
    (click)="submit()"
    data-lokalise
    data-key="txt_next"
  ></button>
</div>
